<template>
  <div :class="elem.classes">
    <div class="row">
      <div :class="elemLabel.classes">
        <FormLabel 
          v-if="!$slots.label"  
          :class="elemFormLabel.classes" 
          :label="label" 
          :labelFont="labelFont"
          :labelHint="labelHint"
          :labelHelp="labelHelp"
          :labelRequired="labelRequired"
        />
        <slot name="label" v-else></slot>
      </div>
      <div :class="elemContent.classes">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import FormLabel from "@components_system/Shared/Elements/Texts/FormLabel";

export default {
  components: {
    FormLabel,
  },
  props: {
    /**
     * Label and Control is disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    // Label
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: [String, Object],
      default: () => {},
    },
    labelFont: {
      type: String,
      default: "fs-sa-14",
    },
    labelTextClass: {
      type: String,
      default: undefined,
    },
    labelHint: {
      type: String,
      default: undefined, // Ex. (Hover)
    },
    labelHelp: {
      type: String,
      default: undefined, // Ex. message
    },
    labelRequired: {
      type: Boolean,
      default: false,
    },

    // Content
    contentClass: {
      type: [String, Object],
      default: () => {},
    },
  },
  computed: {
    // Root
    _labelClass() {
      if (typeof this.labelClass === 'string') return this.labelClass.split(" ").reduce((acc, curr)=> ({...acc, [curr]: true}), {});
      return this.labelClass;
    },
    _contentClass() {
      if (typeof this.contentClass === 'string') return this.contentClass.split(" ").reduce((acc, curr)=> ({...acc, [curr]: true}), {})
      return this.contentClass;
    },

    // Elements
    elem() {
      return { 
        classes: {
          'mwe-formgroup': true,
          'disabled': Boolean(this.disabled),
        },
      };
    },
    elemLabel() {
      let classes = {
        'col-12': true,
        ...this._labelClass,
      };
      return { classes };
    },
    elemContent() {
      let classes = {
        'col-12': true,
        ...this._contentClass,
      };
      return { classes };
    },
    elemFormLabel() {
      return { 
        classes: {
          "mb-gd-1": true,
        },
      };
    },
  }
}
</script>

<style>
.mwe-formgroup.disabled {
  cursor: auto !important;
  opacity: 0.3;
}
.mwe-formgroup.disabled * {
  cursor: auto !important;
}
</style>
